// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__3j-B4","alertIcon":"ConfirmModal_alertIcon__BY9Yq"};